export default function CloseIcon({ color = '#476550' }) {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g id="Cross">
				<path d="M1 1L17 17" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
				<path d="M1 17L17 1" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
			</g>
		</svg>
	);
}